<div class="form-group" [formGroup]="bankFormGroup">
  <ng-container *ngIf="!withoutLabel">
    <label *scText="formFields.fields.domesticBeneficiaryBank.label"></label>
  </ng-container>

  <mat-form-field
    class="d-block ab-select form-control-custom"
    [floatLabel]="'never'"
    hideRequiredMarker
  >
    <mat-select
      [placeholder]="formFields.fields.domesticBeneficiaryBank.placeholder"
      (blur)="onTouched()"
      formControlName="domesticBeneficiaryBank"
    >
      <mat-option *ngFor="let bank of bankList" [value]="bank">
        {{ bank.name }}</mat-option
      >
    </mat-select>
  </mat-form-field>
  <span
    class="field-validation-error"
    *ngIf="domesticBeneficiaryBank.errors?.required"
    >{{ formFields.genericErrors.required.message }}</span
  >
</div>
